import { render } from "./TranslationGenerationStep.vue?vue&type=template&id=06871420"
import script from "./TranslationGenerationStep.vue?vue&type=script&lang=js"
export * from "./TranslationGenerationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__